import { Page, PageFace } from 'ui/components/Page'
import { Panel, PanelFace } from 'ui/components/Panel'

import { ReportBreadcrumbs } from '../../components'
import { Filter } from './components/Filter'
import { PageActions } from './components/PageActions'
import { Table } from './components/Table'
import { UserReportContextProvider } from './context/UserReportContextProvider'

const UserReport = () => (
  <UserReportContextProvider>
    <Page face={PageFace.PRIMARY} title={<ReportBreadcrumbs title="User Report" />} actions={<PageActions />}>
      <Panel rounded shadowed collapsible={false} face={PanelFace.SECONDARY}>
        <Filter />
        <Table />
      </Panel>
    </Page>
  </UserReportContextProvider>
)

export default UserReport
